import { render, staticRenderFns } from "./pesquisaAnotacoes.vue?vue&type=template&id=f5fc1600"
import script from "./pesquisaAnotacoes.vue?vue&type=script&lang=js"
export * from "./pesquisaAnotacoes.vue?vue&type=script&lang=js"
import style0 from "./pesquisaAnotacoes.vue?vue&type=style&index=0&id=f5fc1600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports